<template>
  <module-box
    type="skill-info"
    :mode="mode"
    :moduleData="moduleData"
    showSetup
    @onSetup="handleOpenModuleSetupPanel"
    @onDelete="handleDeleteModule"
    @onMore="handleMore"
  >
    <div class="skill-info">
      <module-title :mode="mode" :title="moduleData.title" @onChange="handleTitleChange"></module-title>
      <div class="container">
        <div class="tabs-box" v-if="moduleData.isShowTabs">
          <filter-tabs
            :mode="mode"
            :activeTab="activeTab"
            :tabs="moduleData.tabs"
            @onAdd="handleTabsAdd"
            @onDelete="handleTabsDelete"
            @onChange="handleTabsChange"
            @onActive="handleTabsActive"
          ></filter-tabs>
        </div>
        <draggable
          v-model="skillList"
          :animation="200"
          :group="'skillInfoList'"
          :disabled="mode !== 'edit'"
          :ghostClass="'ghost'"
          :handle="'.edit-drag'"
          @start="dragSkill = true"
          @end="dragSkill = false"
          @change="handleSortSkill"
        >
          <template v-if="skillList.length > 0">
            <div class="skill-item" v-for="(data, index) in skillList" :key="data.key">
              <info-item
                :mode="mode"
                :data="data"
                :isShowTabs="moduleData.isShowTabs"
                :tabs="moduleData.tabs"
                @onAdd="handleAddInfo(index)"
                @onDelete="handleDeleteInfo(index)"
                @onChange="data => hanldeDataChange(index, data)"
              ></info-item>
            </div>
          </template>
          <template v-else-if="mode == 'edit'">
            <button class="add-btn" @click.stop="handleAddInfo">
              <i class="icon wiki-editable-add"></i>
            </button>
          </template>
        </draggable>
      </div>
    </div>
    <!-- 设置 -->
    <setup-panel v-if="mode === 'edit'" ref="setupPanel" :data="moduleData" @onChange="handleChangeData"></setup-panel>
  </module-box>
</template>

<script>
import draggable from "vuedraggable";
// componets
import ModuleBox from "../../components/ModuleBox";
import InfoItem from "./components/InfoItem";
import ModuleTitle from "../../components/ModuleTitle";
import FilterTabs from "../../components/FilterTabs";
import SetupPanel from "./SetupPanel.vue";

export default {
  name: "SkillInfo",
  components: {
    draggable,
    ModuleBox,
    InfoItem,
    ModuleTitle,
    FilterTabs,
    SetupPanel
  },
  props: {
    mode: String,
    moduleData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dragSkill: false,
      skillList: [],
      activeTab: this.moduleData.isShowTabs && this.moduleData.tabs ? this.moduleData.tabs[0] : null
    };
  },
  computed: {
    filterSkillList() {
      // console.log(1);
      let list = this.moduleData.skillList;
      if (this.activeTab) {
        list = this.moduleData.skillList.filter(item => item.filterTabKey == this.activeTab.key);
      }
      return list;
    }
  },

  watch: {
    moduleData(val) {
      if (!this.activeTab) {
        this.activeTab = val.isShowTabs && val.tabs ? val.tabs[0] : null;
      }
    },
    filterSkillList: {
      handler(val) {
        this.skillList = val;
      },
      immediate: true
    }
  },

  mounted() {},

  methods: {
    // 模块更多操作
    handleMore(command, data) {
      if (command === "copy") {
        const moduleData = JSON.parse(JSON.stringify(this.moduleData));
        this.$emit("onCopy", moduleData);
      }
    },
    // 模块设置
    handleOpenModuleSetupPanel() {
      this.$refs.setupPanel.open();
    },
    handleChangeData(data) {
      this.$emit("onChange", data);
    },
    // 模块删除
    handleDeleteModule() {
      this.$emit("onDelete");
    },
    handleTitleChange(title) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.title = title;
      this.$emit("onChange", moduleData);
    },
    handleSortSkill() {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      if (this.activeTab) {
        let filterList = [];
        let otherList = [];
        moduleData.skillList.forEach(item => {
          if (item.filterTabKey == this.activeTab.key) {
            filterList.push(item);
          } else {
            otherList.push(item);
          }
        });
        filterList = this.skillList;
        moduleData.skillList = [...otherList, ...filterList];
        this.$emit("onChange", moduleData);
      } else {
        moduleData.skillList = this.skillList;
        this.$emit("onChange", moduleData);
      }
    },
    handleAddInfo(index) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const currentSkillInfo = moduleData.skillList[index] || {
        iconSize: {
          width: 67,
          height: 70
        }
      };
      const item = {
        key: Math.random().toString(16),
        isShowIcon: true,
        isShowName: true,
        isShowDesc: true,
        isShowMore: true,
        filterTabKey: this.activeTab ? this.activeTab.key : null,
        iconSize: currentSkillInfo.iconSize,
        icon: "",
        name: "",
        label: "",
        desc: "",
        moreInfo: "",
        moreBtn: "查看升级效果"
      };
      if (this.activeTab) {
        let filterList = [];
        let otherList = [];
        moduleData.skillList.forEach(item => {
          if (item.filterTabKey == this.activeTab.key) {
            filterList.push(item);
          } else {
            otherList.push(item);
          }
        });
        filterList.splice(index + 1, 0, item);
        moduleData.skillList = [...otherList, ...filterList];
        this.$emit("onChange", moduleData);
      } else {
        moduleData.skillList.splice(index + 1, 0, item);
        this.$emit("onChange", moduleData);
      }
    },
    handleDeleteInfo(index) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      if (this.activeTab) {
        let filterList = [];
        let otherList = [];
        moduleData.skillList.forEach(item => {
          if (item.filterTabKey == this.activeTab.key) {
            filterList.push(item);
          } else {
            otherList.push(item);
          }
        });
        filterList.splice(index, 1);
        moduleData.skillList = [...otherList, ...filterList];
        this.$emit("onChange", moduleData);
      } else {
        moduleData.skillList.splice(index, 1);
        this.$emit("onChange", moduleData);
      }
    },
    hanldeDataChange(index, data) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      if (this.activeTab) {
        let filterList = [];
        let otherList = [];
        moduleData.skillList.forEach(item => {
          if (item.filterTabKey == this.activeTab.key) {
            filterList.push(item);
          } else {
            otherList.push(item);
          }
        });
        filterList.splice(index, 1, data);
        moduleData.skillList = [...otherList, ...filterList];
        this.$emit("onChange", moduleData);
      } else {
        moduleData.skillList.splice(index, 1, data);
        this.$emit("onChange", moduleData);
      }
    },
    // tabs add
    handleTabsAdd(index = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));

      if (!moduleData.tabs || moduleData.tabs.length === 0) {
        const fisrtTab = {
          key: Math.random().toString(16),
          label: "标签页"
        };
        moduleData.tabs = [fisrtTab];
        // 遍历所有upgradeList，添加filterTabKey
        moduleData.skillList.forEach(item => {
          item.filterTabKey = fisrtTab.key;
        });
      } else {
        moduleData.tabs.splice(index + 1, 0, {
          key: Math.random().toString(16),
          label: "标签页"
        });
      }

      // 首次添加
      if (!this.activeTab) {
        this.activeTab = moduleData.tabs[0];
      }
      this.$emit("onChange", moduleData);
    },
    // tabs active
    handleTabsActive(index, tab) {
      this.activeTab = tab;
    },
    // tabs delete
    handleTabsDelete(index = 0) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      const deleteTab = moduleData.tabs[index];
      const unbindList = moduleData.skillList.filter(item => item.filterTabKey === deleteTab.key);
      if (unbindList.length > 0) {
        this.$confirm("有绑定该Tab的内容，是否解除绑定后，再删除？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(res => {
            moduleData.tabs.splice(index, 1);
            // 绑定到第一个tab
            const firstTab = moduleData.tabs[0];
            moduleData.skillList.forEach(item => {
              if (item.filterTabKey === deleteTab.key) {
                item.filterTabKey = firstTab ? firstTab.key : null;
              }
            });
            this.activeTab = firstTab;
            this.$emit("onChange", moduleData);
          })
          .catch(() => {});
      } else {
        moduleData.tabs.splice(index, 1);
        // 定位
        const firstTab = moduleData.tabs[0];
        this.activeTab = firstTab;
        this.$emit("onChange", moduleData);
      }
    },
    // tabs change
    handleTabsChange(index = 0, tab) {
      const moduleData = JSON.parse(JSON.stringify(this.moduleData));
      moduleData.tabs.splice(index, 1, tab);
      this.$emit("onChange", moduleData);
    }
  }
};
</script>

<style lang="less" scoped>
.skill-info {
  .container {
    padding: 12px 5px 7px 29px;
    .tabs-box {
      margin-bottom: 12px;
    }
  }
  /deep/ .skill-item {
    margin-bottom: 12px;
    &:last-child {
      .skill-main {
        border-bottom: none;
      }
    }
  }
  .add-btn {
    width: 20px;
    height: 20px;
    color: #ffffff;
    border-radius: 4px;
    margin-left: 3px;
    border: none;
    vertical-align: middle;
    line-height: 20px;
    text-align: center;
    &:hover {
      opacity: 0.9;
    }
    .icon {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
